<div class="change-theme">
    <mat-slide-toggle [(ngModel)]="model.isLightTheme" (change)="toggleTheme()"></mat-slide-toggle>
</div>